import {
  OverallTotalStatisticInterface, OverallUserStatisticInterface,
  StatisticFilterData,
  StatisticPeriodInterface,
  StatisticRepositoryInterface,
  TotalStatisticInterface,
  UserStatisticInterface,
} from '@/services/QC-V2/statistic/interfaces';
import { AxiosInstance } from 'axios';

export default class StatisticRepository implements StatisticRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getOverallTotalStatistic(filterData: StatisticFilterData): Promise<OverallTotalStatisticInterface> {
    let url = `/qa-statistics-v2/statistics/overall?${this.createQueryParameters(filterData)}`;

    const response = await this.axios.get(url);

    return response.data;
  }

  public async getOverallUserStatistic(
    filterData: StatisticFilterData,
  ): Promise<[OverallUserStatisticInterface[], number]> {
    let url = `/qa-statistics-v2/statistics/users?${this.createQueryParameters(filterData)}`;
    const response = await this.axios.get(url);

    return response.data;
  }

  public async findUserStatistic(userId: string, period?: StatisticPeriodInterface): Promise<UserStatisticInterface[]> {
    let url = `qa-statistics-v2/statistics/users/${userId}`;
    if (period) {
      url = `${url}?${Object.keys(period).reduce((res, key) => `${res}&${key}=${period[key]}`, '')}`;
    }

    const response = await this.axios.get(url);

    return response.data;
  }

  private createQueryParameters(filterData: StatisticFilterData): string {
    const parameters: string[] = [];
    Object.keys(filterData).forEach((filterKey) => {
      if (!filterData[filterKey]) {
        return;
      }

      parameters.push(`${filterKey}=${filterData[filterKey]}`);
    });

    if (!parameters.length) {
      return '';
    }

    return parameters.join('&');
  }
}
